export const DEFAULT_DIALOGS_PANEL_CLASS = {
    panelClass: ['aw-modal', 'modal-alert', 'modal-lg'],
};
